<h1 class="text-center mt-2">Gestion des receptions autonomes</h1>
<div class="user-table mt-4">
  <div class="container-row d-flex justify-content-between top-field">
    <div class="btn1">
      <button (click)="SelectChangeHandlerCreer()" id="btn-add-concession" class="mr-5 btn btn-dark">
        <mat-icon>add_circle</mat-icon> Reception autonome
      </button>
    </div>
    <mat-form-field class="m-3">
      <mat-label>Rechercher</mat-label>
      <input [(ngModel)]="search" matInput (keyup)="applyFilter($event)">
    </mat-form-field>
  </div>
</div>

<div class="example-container">
  <table mat-table [dataSource]="dataSource" class="user-table mat-elevation-z8 mb-3">

    <ng-container matColumnDef="concession">
      <th mat-header-cell *matHeaderCellDef> Concession </th>
      <td mat-cell *matCellDef="let element"> {{element.concession}} </td>
    </ng-container>

    <ng-container matColumnDef="uniq_concession_id">
      <th mat-header-cell *matHeaderCellDef> Identifiant unique </th>
      <td mat-cell *matCellDef="let element"> {{element.uniq_concession_id}} </td>
    </ng-container>

    <ng-container matColumnDef="reception_expires_at_delay">
      <th mat-header-cell *matHeaderCellDef> Délai de fin de validité (réception) </th>
      <td mat-cell *matCellDef="let element"> {{element.reception_expires_at_delay}} min</td>
    </ng-container>

    <ng-container matColumnDef="reception_not_before_delay">
      <th mat-header-cell *matHeaderCellDef> Délai de début de validité </th>
      <td mat-cell *matCellDef="let element"> {{element.reception_not_before_delay}} min</td>
    </ng-container>

    <ng-container matColumnDef="restitution_expires_at_delay">
      <th mat-header-cell *matHeaderCellDef> Délai de fin de validité (restitution) </th>
      <td mat-cell *matCellDef="let element"> {{element.restitution_expires_at_delay}} min</td>
    </ng-container>

    <ng-container matColumnDef="service">
      <th mat-header-cell *matHeaderCellDef> Service </th>
      <td mat-cell *matCellDef="let element"> {{element.service}} </td>
    </ng-container>

    <ng-container matColumnDef="modifier">
      <th mat-header-cell *matHeaderCellDef> Modifier </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="SelectChangeHandlerModifier(element.id)" class="m-2 btn btn-round-40 btn-dark">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
                 (click)="displayPaginatorAllOption()"
                 (page)="pageChange()"
                 showFirstLastButtons
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
